import Prajavani_otp_icon from "../../images/prajavani-otp-icon.svg";
import Prajavani_logo from "../../images/prajavani-logo-img.svg";
import DHSplashScreen from "../../component/DHSplashScreen";
import Header from "../../component/Header";
import { useNavigate } from "react-router-dom";
import {
  PRAJAVANI_MOBILE_TAB,
  REDIRECT_URL,
  SELECTED_TAB_SEARCH_QUERY_PARAM_NAME,
  email_tab_indetifier,
  mobile_tab_indetifier,
} from "../../contant";
import Footer from "../../component/Footer";
import PrajavaniOtpForm from "../../component/PrajavaniOtpForm";

export default function PrajavaniOTPPage({
  reference,
  OTP,
  setOTP,
  otpError,
  setOtpError,
  isDisableVerifyBtn,
  setIsDisableVeifyBtn,
  isDisableResendBtn,
  setIsDisableResendBtn,
  tabDetail,
  handleOTPInput,
  resendOTP,
  progress,
  pathname,
  fieldTobeUpdateData,
  userOTP,
  setUserOTP,
  userOtpError,
  setIsDisableUserVerifyBtn,
  isDisableUserVerifyBtn,
  emailRequired,
  signupMessage,
  isEmailUpdateOrPhoneNumber,
  setUserOtpError
}) {
  const navigate = useNavigate();
  const userLoginDetail =
    JSON.parse(window.localStorage.getItem("user_login_detail")) || {};
  return (
    <div className="xxl:min-h-dvh xxxl:flex xxxl:flex-row xxxl:items-center xxxl:justify-center short-screen-spacing">
      <div className="flex flex-row w-full text-center lg:pt-8 px-10 md:p-0 md:pt-2 xxxl:pt-0 sm:min-h-mobile">
        <DHSplashScreen
          className={"div-with-bg-prajavani"}
          logoImage={Prajavani_logo}
        />
        <div className="w-1/2 shadow-md bg-white ml-2 rounded-2xl sm:w-full sm:ml-0 sm:flex sm:flex-col">
          <Header
            headerImage={Prajavani_otp_icon}
            className={"bg-yellow-400"}
          />
          <p className="text-gray-700 font-semibold mt-[72px] mb-3 text-2xl font-notoSans">
            ದೃಢೀಕರಣ
          </p>
          {pathname.includes("post_change_email") ? (
            <p className="px-12 text-base text-gray-700 text-center font-normal leading-7 mt-2 font-notoSans mb-24">
              ಇಮೇಲ್ ಮೂಲಕ <span className="text-gray-700 font-bold font-notoSans">
                {fieldTobeUpdateData}
              </span>{" "} ಗೆ ಕಳುಹಿಸಲಾದ ಒಟಿಪಿ ಬಳಸಿ ದೃಢೀಕರಿಸಿ{" "}
              <span
                className="text-cyan-500 font-medium cursor-pointer font-notoSans"
                onClick={() => navigate(`/auth/change_email`)}
              >
                ಬದಲಾಯಿಸಿ
              </span>
            </p>
          ) : pathname.includes("post_change_phonenumber") ? (
            <p className="px-12 text-base text-gray-700 text-center font-normal leading-7 mt-2 font-notoSans mb-24">
              SMS ಮೂಲಕ <span className="text-gray-700 font-bold font-notoSans">
                {`+91 ${fieldTobeUpdateData}`}
              </span>{" "} ನಂಬರಿಗೆ ಕಳುಹಿಸಲಾದ ಒಟಿಪಿ ಬಳಸಿ ದೃಢೀಕರಿಸಿ{" "}
              <span
                className="text-cyan-500 font-medium cursor-pointer font-notoSans"
                onClick={() => navigate(`/auth/change_phonenumber`)}
              >
                ಬದಲಾಯಿಸಿ
              </span>
            </p>
          ) : tabDetail === PRAJAVANI_MOBILE_TAB ? (
            <p className="px-12 text-base text-gray-700 text-center font-normal leading-7 mt-2 font-notoSans mb-24">
              SMS ಮೂಲಕ <span className="text-gray-700 font-bold font-notoSans">
                {`+91 ${userLoginDetail.phone}`}
              </span>{" "}
              ನಂಬರಿಗೆ ಕಳುಹಿಸಲಾದ ಒಟಿಪಿ ಬಳಸಿ ದೃಢೀಕರಿಸಿ{" "}
              <span
                className="text-cyan-500 font-medium cursor-pointer font-notoSans"
                onClick={() =>
                  navigate(
                    `/auth?${REDIRECT_URL}=${reference}${emailRequired !== "null"
                      ? `&emailRequired=${emailRequired}`
                      : ""
                    }${signupMessage !== "null"
                      ? `&signupMessage=${signupMessage}`
                      : ""
                    }${tabDetail === PRAJAVANI_MOBILE_TAB
                      ? `&${SELECTED_TAB_SEARCH_QUERY_PARAM_NAME}=${mobile_tab_indetifier}`
                      : `&${SELECTED_TAB_SEARCH_QUERY_PARAM_NAME}=${email_tab_indetifier}`
                    }`
                  )
                }
              >
                ಬದಲಾಯಿಸಿ
              </span>
            </p>
          ) : (
            <p className="px-12 text-base text-gray-700 text-center font-normal leading-7 mt-2 font-notoSans mb-24">
              ಇಮೇಲ್ ಮೂಲಕ <span className="text-gray-700 font-bold font-notoSans">
                {userLoginDetail.email}
              </span>{" "}
              ಗೆ ಕಳುಹಿಸಲಾದ ಒಟಿಪಿ ಬಳಸಿ ದೃಢೀಕರಿಸಿ {" "}
              <span
                className="text-cyan-500 font-medium cursor-pointer font-notoSans"
                onClick={() =>
                  navigate(
                    `/auth?${REDIRECT_URL}=${reference}${emailRequired !== "null"
                      ? `&emailRequired=${emailRequired}`
                      : ""
                    }${signupMessage !== "null"
                      ? `&signupMessage=${signupMessage}`
                      : ""
                    }`
                  )
                }
              >
                ಬದಲಾಯಿಸಿ
              </span>
            </p>
          )}

          <PrajavaniOtpForm
            tabDetail={tabDetail}
            reference={reference}
            OTP={OTP}
            setOTP={setOTP}
            otpError={otpError}
            setOtpError={setOtpError}
            isDisableVerifyBtn={isDisableVerifyBtn}
            setIsDisableVeifyBtn={setIsDisableVeifyBtn}
            isDisableResendBtn={isDisableResendBtn}
            setIsDisableResendBtn={setIsDisableResendBtn}
            handleOTPInput={handleOTPInput}
            resendOTP={resendOTP}
            progress={progress}
            pathname={pathname}
            setUserOTP={setUserOTP}
            userOTP={userOTP}
            userOtpError={userOtpError}
            setIsDisableUserVerifyBtn={setIsDisableUserVerifyBtn}
            isDisableUserVerifyBtn={isDisableUserVerifyBtn}
            isEmailUpdateOrPhoneNumber={isEmailUpdateOrPhoneNumber}
            setUserOtpError={setUserOtpError}
          />
          <Footer footerLable={"ನಿಮ್ಮ ಲಾಗಿನ್, ಈಗ ಸರಳ"} className="sm:mt-auto" />
        </div>
      </div>
    </div>
  );
}
